module.exports = require('fast-deep-equal/es6')
